import { useMemo, useCallback } from "react";

export const useLogsFilter = (classLogs, selectedDepartment) => {
	const logsByDateAndPeriod = useMemo(() => {
		if (!classLogs || !selectedDepartment) return {};

		const map = {};
		classLogs.forEach((log) => {
			if (log.departmentId === selectedDepartment) {
				const logDate = new Date(log.classDate).toISOString().split("T")[0];
				const key = `${logDate}-${log.period}`;
				if (!map[key]) map[key] = [];
				map[key].push(log);
			}
		});

		return map;
	}, [classLogs, selectedDepartment]);

	const getLogsForPeriod = useCallback(
		(dateFormatted, period) => {
			const key = `${dateFormatted}-${period}`;
			return logsByDateAndPeriod[key] || [];
		},
		[logsByDateAndPeriod]
	);

	const hasConflicts = useCallback((logs) => logs.length > 1, []);
	const isMissing = useCallback((logs) => logs.length === 0, []);

	return {
		getLogsForPeriod,
		hasConflicts,
		isMissing,
	};
};
